import React, { memo } from 'react';
import { ProductoCard, Producto } from './ProductoCard';
type Props = {
  id: string;
  variant: 'origen' | 'memoria' | 'pausa';
  numero: string;
  nombre: string;
  descripcion: string;
  productos: Producto[];
  testimonio: {
    quote: string;
    autor: string;
  };
};
export function Coleccion({
  id,
  variant,
  numero,
  nombre,
  descripcion,
  productos
}: Props) {
  return <section className={`coleccion coleccion--${variant}`} id={id} data-id="element-72" data-mp="2xkp5agduu6yg">
      <div className="savia-container" data-id="element-73" data-mp="2xje1whobn17v">
        <div className="coleccion__header" data-id="element-74" data-mp="32kjvehpt2sig">
          <div className="reveal-left" data-id="element-75" data-mp="32jih84dhtpwi">
            <p className="coleccion__numero" data-id="element-76" data-mp="2ol22bq5h8t3a">{numero}</p>
            <h2 className="coleccion__nombre" data-id="element-77" data-mp="2ok9114paevsj">{nombre}</h2>
          </div>
          <p className="coleccion__descripcion reveal-right" data-id="element-78" data-mp="2tiam1v69x56n">{descripcion}</p>
        </div>
        <div className="coleccion__grid" data-id="element-79" data-mp="1d4c1ynnqivhl">
          {productos.map((p, i) => <ProductoCard key={p.nombre} producto={p} delay={i + 1} data-id="element-80" data-mp="1i4zvbfzfroez" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}